import { render, staticRenderFns } from "./ListDatasetCollectionElementView.vue?vue&type=template&id=37c01458&scoped=true"
import script from "./ListDatasetCollectionElementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListDatasetCollectionElementView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListDatasetCollectionElementView.vue?vue&type=style&index=0&id=37c01458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c01458",
  null
  
)

export default component.exports